import Repository from "./repository"

export default {
    /**
     * 販売種別利用制限チェック処理API
     */
    view() {
        return Repository.get('/api/c207-check-sales-channel/view')
    },
}
